import { Outlet, NavLink } from 'react-router-dom'
import {
  Package,
  Hash,
  Percent,
  Ruler,
  CreditCard,
  FileCheck,
  FileText as FileTextIcon,
  Briefcase,
  Banknote,
  Stamp,
  Settings,
  LayoutGrid,
  Layers,
} from 'lucide-react'

const MASTER_DATA_TABS = [
  { key: 'products-services', label: 'Products & Services', href: '/app/settings/master-data/products-services', icon: Package },
  { key: 'hsn-sac', label: 'HSN / SAC', href: '/app/settings/master-data/hsn-sac', icon: Hash },
  { key: 'taxes', label: 'Taxes / GST', href: '/app/settings/master-data/taxes', icon: Percent },
  { key: 'units', label: 'Units', href: '/app/settings/master-data/units', icon: Ruler },
  { key: 'payment-terms', label: 'Payment Terms', href: '/app/settings/master-data/payment-terms', icon: CreditCard },
  { key: 'assumptions-exclusions', label: 'Assumptions & Exclusions', href: '/app/settings/master-data/assumptions-exclusions', icon: FileCheck },
  { key: 'terms-conditions', label: 'Terms & Conditions', href: '/app/settings/master-data/terms-conditions', icon: FileTextIcon },
  { key: 'bank-details', label: 'Bank Details', href: '/app/settings/master-data/bank-details', icon: Banknote },
  { key: 'declarations', label: 'Declarations', href: '/app/settings/master-data/declarations', icon: Stamp },
  { key: 'quotation-defaults', label: 'Quotation Defaults', href: '/app/settings/master-data/quotation-defaults', icon: Briefcase },
  { key: 'display-settings', label: 'Document Display', href: '/app/settings/master-data/display-settings', icon: LayoutGrid },
  { key: 'document-numbering', label: 'Document Numbering', href: '/app/settings/master-data/document-numbering', icon: Settings },
  { key: 'asset-master-data', label: 'Asset Categories & Statuses', href: '/app/settings/master-data/asset-master-data', icon: Layers },
]

export default function MasterDataLayout() {
  return (
    <div className="space-y-5">
      {/* Horizontal Tabs Subnavigation */}
      <div className="border-b border-border pb-2.5 overflow-x-auto no-scrollbar">
        <div className="flex items-center gap-1.5 min-w-max">
          {MASTER_DATA_TABS.map((tab) => (
            <NavLink
              key={tab.key}
              to={tab.href}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-lg transition-all ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-2xs'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`
              }
            >
              <tab.icon className="h-3.5 w-3.5 shrink-0" />
              <span>{tab.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  )
}